export default __webpack_public_path__ + "static/media/otherworldly_story.48b54293.png";